import { render, staticRenderFns } from "./FormContato.vue?vue&type=template&id=67b6afe6&scoped=true&"
import script from "./FormContato.vue?vue&type=script&lang=js&"
export * from "./FormContato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b6afe6",
  null
  
)

export default component.exports